export default __webpack_public_path__ + "static/media/CDU.dcf77a16.png";